import { FC, FormEvent, useEffect, useState } from "react";

export class LecalSectionProps {
  title: string = '';
  value: string = '';
}

export const LecalSection: FC<LecalSectionProps> = ({title, value}) => {
  return <>
    <h2 className="mt-6 text-[24px]">{title}</h2>
    <div className="whitespace-pre-line">{value}</div>
  </>;
}